import axios from '~/common/plugins/axios.js'
export const state = () => ({
  wxOfficial: {
    visible: false,
    type: ''
  },
  dyOfficial: {
    visible: false,
    type: ''
  },
  businessTypes:[]
});

export const mutations = {
  set_wxOfficial(state, v) {
    state.wxOfficial= v;
  },
  set_dyOfficial(state, v) {
    state.dyOfficial= v;
  },
  set_businessTypes(state, v) {
    state.businessTypes= v;
  },
};
const getters = {

}
const actions = {
  getApiBusinessType({commit,state},payload) {
    if(state.businessTypes?.length) {
      return state.businessTypes
    }
    return axios.$get('/rest/store/general/v3/dictionaries/GetDicInfoListByType?type=InterfaceBizType').then(res => {
      if (res.code !== 200) return;
      const tmp = res.data.data.list.map((res) => {
        const {dcode, name} = res
        return {
          ...res,
          value: dcode,
          label:name,
          id: dcode
        }
      })
      commit('set_businessTypes', tmp)
      return state.businessTypes
    })
  }
}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
  getters
}
